// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import {
  type ZugewieseneRechnungBaustelle,
  ZugewieseneRechnungBaustelleDaten,
} from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type AssignBaustelleZuRechnungQuery = { rechnungBeglichenAm?: string };

export function useAssignBaustelleZuRechnung(): (
  rechnungsId: string,
  query: AssignBaustelleZuRechnungQuery,
  requestBody: ZugewieseneRechnungBaustelleDaten
) => Promise<ZugewieseneRechnungBaustelle> {
  const getAPI = useGetApi();
  return useCallback(
    async (rechnungsId, query = {}, requestBody) =>
      (await getAPI()).rechnungen.assignBaustelleZuRechnung({
        rechnungsId,
        ...query,
        requestBody,
      }),
    [getAPI]
  );
}
